import { z } from "zod";

export const rawNullableStringSchema = z.object({ raw: z.string().nullable() });
